export const ourProducts = [
    {
      title: 'E-commerce Platforms with Personalization Features', 
      subtitle:
        'Elevate your online retail experience with our E-commerce Platforms. Enjoy seamless transactions, intuitive navigation, and personalized shopping recommendations that enhance the overall customer journey.',
      img: 'url(/industries/retail/e-commerce-platforms.avif)',
      content:
        'Enjoy seamless transactions, intuitive navigation, and personalized shopping recommendations that enhance the overall customer journey with our E-commerce Platforms.',
      link: '/industries/retail/products/e-commerce-platforms', 
    },
    {
      title: 'Point of Sale (POS) and Inventory Management Systems',
      subtitle:
        'Streamline your retail operations with our POS and Inventory Management Systems. Simplify transactions, track inventory in real-time, and optimize order fulfillment for a more efficient retail environment.',
      img: 'url(/industries/retail/pos-and-inventory-management-systems.jpg)',
      content:
        'Simplify transactions, track inventory in real-time, and optimize order fulfillment for a more efficient retail environment with our Point of Sale (POS) and Inventory Management Systems.',
      link: '/industries/retail/products/pos-and-inventory-management-systems',
    },
    {
      title: 'Augmented Reality Shopping Applications',
      subtitle:
        'Transform the way customers shop with Augmented Reality Applications. Allow them to virtually try products before purchasing, enhancing engagement and providing a unique and immersive shopping experience.',
      img: 'url(/industries/retail/augmented-reality-shopping-applications.avif)',
      content:
        'Allow customers to virtually try products before purchasing, enhancing engagement and providing a unique and immersive shopping experience with our Augmented Reality Shopping Applications.',
      link: '/industries/retail/products/augmented-reality-shopping-applications',
    },
    {
      title: 'Customer Relationship Management (CRM) Systems for Retail',
      subtitle:
        'Build lasting customer relationships with our CRM Systems. Capture customer preferences, personalize interactions, and deliver exceptional service to cultivate loyalty and drive repeat business.',
      img: 'url(/industries/retail/crm-systems-for-retail.jpg)',
      content:
        'Capture customer preferences, personalize interactions, and deliver exceptional service to cultivate loyalty and drive repeat business with our Customer Relationship Management (CRM) Systems for Retail.',
      link: '/industries/retail/products/crm-systems-for-retail',
    },
    {
      title: 'Retail Analytics and Predictive Merchandising Software',
      subtitle:
        'Make data-driven decisions with Retail Analytics and Predictive Merchandising Software. Analyze customer behavior, forecast trends, and optimize inventory to ensure the right products are in the right place at the right time.',
      img: 'url(/industries/retail/retail-analytics-and-predictive-merchandising-software.jpg)',
      content:
        'Analyze customer behavior, forecast trends, and optimize inventory to ensure the right products are in the right place at the right time with our Retail Analytics and Predictive Merchandising Software.',
      link: '/industries/retail/products/retail-analytics-and-predictive-merchandising-software',
    },
    {
      title: 'Omnichannel Retail Management Platforms',
      subtitle:
        'Unify your retail channels with Omnichannel Management Platforms. Provide a seamless shopping experience across online and offline channels, enabling customers to interact with your brand consistently.',
      img: 'url(/industries/retail/omnichannel-retail-management-platforms.avif)',
      content:
        'Provide a seamless shopping experience across online and offline channels, enabling customers to interact with your brand consistently with our Omnichannel Retail Management Platforms.',
      link: '/industries/retail/products/omnichannel-retail-management-platforms',
    },
    {
      title: 'Intelligent Shelf Management Systems',
      subtitle:
        'Enhance in-store efficiency with Intelligent Shelf Management Systems. Optimize product placement, monitor inventory levels, and minimize out-of-stock situations to ensure a well-organized and customer-friendly store layout.',
      img: 'url(/industries/retail/intelligent-shelf-management-systems.jpg)',
      content:
        'Optimize product placement, monitor inventory levels, and minimize out-of-stock situations to ensure a well-organized and customer-friendly store layout with our Intelligent Shelf Management Systems.',
      link: '/industries/retail/products/intelligent-shelf-management-systems',
    },
    {
      title: 'Beacon Technology for In-Store Customer Engagement',
      subtitle:
        'Revolutionize in-store customer engagement with Beacon Technology. Deliver personalized promotions, notifications, and location-based services, creating a more interactive and personalized shopping environment.',
      img: 'url(/industries/retail/beacon-technology-for-in-store-customer-engagement.jpg)',
      content:
        'Deliver personalized promotions, notifications, and location-based services, creating a more interactive and personalized shopping environment with our Beacon Technology for In-Store Customer Engagement.',
      link: '/industries/retail/products/beacon-technology-for-in-store-customer-engagement',
    },
    {
      title: 'Mobile Shopping and Payment Applications',
      subtitle:
        'Simplify the shopping experience with our Mobile Shopping and Payment Applications. Enable customers to browse, purchase, and pay securely through their mobile devices, enhancing convenience and speed.',
      img: 'url(/industries/retail/mobile-shopping-and-payment-applications.jpg)',
      content:
        'Enable customers to browse, purchase, and pay securely through their mobile devices, enhancing convenience and speed with our Mobile Shopping and Payment Applications.',
      link: '/industries/retail/products/mobile-shopping-and-payment-applications',
    },
    {
      title: 'AI-Driven Virtual Stylist Applications',
      subtitle:
        'Elevate the fashion retail experience with AI-Driven Virtual Stylist Applications. Offer personalized style recommendations based on individual preferences, creating a more engaging and tailored shopping journey.',
      img: 'url(/industries/retail/ai-driven-virtual-stylist-applications.jpg)',
      content:
        'Offer personalized style recommendations based on individual preferences, creating a more engaging and tailored shopping journey with our AI-Driven Virtual Stylist Applications.',
      link: '/industries/retail/products/ai-driven-virtual-stylist-applications',
    },
    {
      title: 'Retail Employee Training and Performance Management Software',
      subtitle:
        'Invest in your staff with Retail Employee Training and Performance Management Software. Streamline training programs, monitor performance, and enhance employee engagement to deliver exceptional customer service.',
      img: 'url(/industries/retail/retail-employee-training-and-performance-management-software.avif)',
      content:
        'Streamline training programs, monitor performance, and enhance employee engagement to deliver exceptional customer service with our Retail Employee Training and Performance Management Software.',
      link: '/industries/retail/products/retail-employee-training-and-performance-management-software',
    },
    {
      title: 'Supply Chain Visibility and Collaboration Platforms',
      subtitle:
        'Optimize your supply chain with Visibility and Collaboration Platforms. Improve transparency, collaboration, and efficiency across the supply chain for enhanced product availability and reduced lead times.',
      img: 'url(/industries/retail/supply-chain-visibility-and-collaboration-platforms.avif)',
      content:
        'Improve transparency, collaboration, and efficiency across the supply chain for enhanced product availability and reduced lead times with our Supply Chain Visibility and Collaboration Platforms.',
      link: '/industries/retail/products/supply-chain-visibility-and-collaboration-platforms',
    },
    {
      title: 'Order Fulfillment and Logistics Optimization Software',
      subtitle:
        'Ensure timely and efficient order fulfillment with our Logistics Optimization Software. Streamline logistics, minimize shipping costs, and maximize customer satisfaction through accurate and prompt deliveries.',
      img: 'url(/industries/retail/order-fulfillment-and-logistics-optimization-software.avif)',
      content:
        'Streamline logistics, minimize shipping costs, and maximize customer satisfaction through accurate and prompt deliveries with our Order Fulfillment and Logistics Optimization Software.',
      link: '/industries/retail/products/order-fulfillment-and-logistics-optimization-software',
    },
    {
      title: 'Loyalty Program Management Solutions',
      subtitle:
        'Build customer loyalty with our Loyalty Program Management Solutions. Create personalized rewards, incentives, and promotions to foster long-term customer relationships and repeat business.',
      img: 'url(/industries/retail/loyalty-program-management-solutions.jpg)',
      content:
        'Create personalized rewards, incentives, and promotions to foster long-term customer relationships and repeat business with our Loyalty Program Management Solutions.',
      link: '/industries/retail/products/loyalty-program-management-solutions',
    },
    {
      title: 'Digital Signage and In-Store Experience Platforms',
      subtitle:
        'Elevate in-store experiences with Digital Signage and Experience Platforms. Engage customers with dynamic displays, interactive features, and immersive content, creating a memorable and enjoyable shopping atmosphere.',
      img: 'url(/industries/retail/digital-signage-and-in-store-experience-platforms.avif)',
      content:
        'Engage customers with dynamic displays, interactive features, and immersive content, creating a memorable and enjoyable shopping atmosphere with our Digital Signage and In-Store Experience Platforms.',
      link: '/industries/retail/products/digital-signage-and-in-store-experience-platforms',
    },
    {
      title: 'Retail Merchandising and Assortment Planning Software',
      subtitle:
        'Optimize your product offerings with Merchandising and Assortment Planning Software. Analyze sales data, forecast trends, and plan assortments to ensure your inventory aligns with customer preferences.',
      img: 'url(/industries/retail/retail-merchandising-and-assortment-planning-software.jpg)',
      content:
        'Analyze sales data, forecast trends, and plan assortments to ensure your inventory aligns with customer preferences with our Retail Merchandising and Assortment Planning Software.',
      link: '/industries/retail/products/retail-merchandising-and-assortment-planning-software',
    },
    {
      title: 'Customer Feedback and Satisfaction Survey Tools',
      subtitle:
        'Prioritize customer satisfaction with Feedback and Survey Tools. Collect valuable insights, measure customer sentiment, and address feedback to continuously enhance the customer experience.',
      img: 'url(/industries/retail/customer-feedback-and-satisfaction-survey-tools.jpg)',
      content:
        'Collect valuable insights, measure customer sentiment, and address feedback to continuously enhance the customer experience with our Customer Feedback and Satisfaction Survey Tools.',
      link: '/industries/retail/products/customer-feedback-and-satisfaction-survey-tools',
    },
    {
      title: 'Social Commerce and Influencer Marketing Platforms',
      subtitle:
        'Leverage social commerce with our Influencer Marketing Platforms. Collaborate with influencers, amplify your brand presence on social media, and drive sales through engaging and authentic content.',
      img: 'url(/industries/retail/social-commerce-and-influencer-marketing-platforms.avif)',
      content:
        'Collaborate with influencers, amplify your brand presence on social media, and drive sales through engaging and authentic content with our Social Commerce and Influencer Marketing Platforms.',
      link: '/industries/retail/products/social-commerce-and-influencer-marketing-platforms', 
    },
    {
      title: 'Dynamic Pricing and Promotion Optimization Software',
      subtitle:
        'Maximize revenue with Dynamic Pricing and Promotion Optimization Software. Adjust pricing strategies dynamically, optimize promotions, and respond to market trends to ensure competitive pricing and increased sales.',
      img: 'url(/industries/retail/dynamic-pricing-and-promotion-optimization-software.jpg)',
      content:
        'Adjust pricing strategies dynamically, optimize promotions, and respond to market trends to ensure competitive pricing and increased sales with our Dynamic Pricing and Promotion Optimization Software.',
      link: '/industries/retail/products/dynamic-pricing-and-promotion-optimization-software',
    },
    {
      title: 'Sustainable Retail Practices Tracking Software',
      subtitle:
        'Embrace sustainability with our Practices Tracking Software. Monitor and report on eco-friendly initiatives, track sustainable sourcing, and communicate your commitment to environmentally conscious retail practices.',
      img: 'url(/industries/retail/sustainable-retail-practices-tracking-software.jpg)',
      content:
        'Monitor and report on eco-friendly initiatives, track sustainable sourcing, and communicate your commitment to environmentally conscious retail practices with our Sustainable Retail Practices Tracking Software.',
      link: '/industries/retail/products/sustainable-retail-practices-tracking-software',
    },
  ]

